module.exports = {
  'en-CA': 1,
  'en-GB': 44,
  'en-IE': 353,
  'en-US': 1,
  'es-ES': 34,
  'es-MX': 52,
  'hi-IN': 91,
  'fr-FR': 33,
  'zh-CN': 86,
  'es-US': 1,
  'es-CL': 56,
  'pt-BR': 55,
  'fr-CA': 1,
}
